import React from "react";
import { Card, CardTitle, CardBody, Col, Row } from "reactstrap";

const AuditInfo = ({ createdOn, createdBy, modifiedOn, modifiedBy }) => {
  return (
    <Card className="mb-4">
      <CardTitle tag="h5">Audit</CardTitle>
      <CardBody>
        <Row>
          <Col>
            <p className="mb-2">
              <i style={{ color: "#9d9c9c" }}>
                <span
                  style={{
                    display: "flex",
                    width: "9em",
                    whiteSpace: "nowrap",
                  }}
                ></span>
                Créée le :
              </i>{" "}
              {createdOn}
            </p>
            {modifiedOn ? (
              <p className="mb-2">
                <i style={{ color: "#9d9c9c" }}>
                  <span
                    style={{
                      display: "flex",
                      width: "9em",
                      whiteSpace: "nowrap",
                    }}
                  ></span>
                  Modifiée le :{" "}
                </i>{" "}
                {modifiedOn}
              </p>
            ) : null}
          </Col>
          <Col>
            <p className="mb-2">
              <i style={{ color: "#9d9c9c" }}>
                <span
                  style={{
                    display: "flex",
                    width: "9em",
                    whiteSpace: "nowrap",
                  }}
                ></span>
                Créée par :
              </i>{" "}
              {createdBy}
            </p>
            {modifiedBy ? (
              <p className="mb-2">
                <i style={{ color: "#9d9c9c" }}>
                  <span
                    style={{
                      display: "flex",
                      width: "9em",
                      whiteSpace: "nowrap",
                    }}
                  ></span>
                  Modifiée par :{" "}
                </i>
                {modifiedBy}
              </p>
            ) : null}
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default AuditInfo;
